import React, { useMemo, useState } from "react";
import "../../css/help-center.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const HelpCenter = () => {
  const { t, i18n } = useTranslation();
  const sections = useMemo(() => {
    const raw = t("help.sections", { returnObjects: true });
    if (!Array.isArray(raw)) return [];
    return raw.map((sec) => ({
      ...sec,
      faqs: (sec.faqs || []).map((f) => ({
        ...f,
        q: f.q,
        a: f.a,
      })),
    }));
  }, [t, i18n.language]);

  const [open, setOpen] = useState(() =>
    sections.reduce((acc, s) => {
      acc[s.key] = 0;
      return acc;
    }, {})
  );

  const toggle = (sectionKey, idx) => {
    setOpen((prev) => ({
      ...prev,
      [sectionKey]: prev[sectionKey] === idx ? -1 : idx,
    }));
  };

  return (
    <div>
      <Header />
      <main className="help-page">
        <div className="help__container">
          <h1 className="help__title">{t("help.title")}</h1>
          <p className="help__intro">{t("help.intro1")}</p>

          <p className="help__intro">{t("help.intro2")}</p>

          {sections.map((sec) => (
            <section key={sec.key} className="help-sec" aria-label={sec.title}>
              <h2 className="help-sec__title"> 
                {sec.title}
              </h2>
              <div className="faq-list">
                {sec.faqs.map((f, i) => (
                  <div
                    key={`${sec.key}-${i}`}
                    className={`faq ${open[sec.key] === i ? "open" : ""}`}
                  >
                    <button
                      className="faq__head"
                      onClick={() => toggle(sec.key, i)}
                    >
                      <span
                        className={`faq__q ${open[sec.key] === i ? "active" : ""
                          }`}
                      >
                        {f.q}
                      </span>
                      <span className="faq__toggle">
                        {open[sec.key] === i ? "−" : "＋"}
                      </span>
                    </button>
                    <div className={`faq__body ${open[sec.key] === i ? "open" : ""}`}>
                      {f.a.map((line, idx) => {
                        // 与 i18n 中允许的富文本标签一致（含外链 <a>、上标 <sup> 等）
                        if (
                          typeof line === "string" &&
                          /<\/?(strong|b|em|i|ul|ol|li|br|a|sup)\b/i.test(
                            line
                          )
                        ) {
                          return (
                            <div
                              key={`a-${idx}`}
                              dangerouslySetInnerHTML={{ __html: line }}
                            />
                          );
                        }
                        return <p key={`a-${idx}`}>{line}</p>;
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </section>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HelpCenter;
